export default __webpack_public_path__ + "static/media/reoccuring.5f3adea4.svg";